import storageLocal from 'redux-persist/es/storage';

export default {
  key: 'root',
  storage: storageLocal,
  blacklist: [],
};
